// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PatientAccountPatientRegistrationIPatientRegistrationData {
    'accountId': number;
    'userId': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PatientAccountPatientRegistrationIPatientRegistrationData>> = [
        {
            "name":     "accountId",
            "baseName": "accountId",
            "type":     "number"
        },
        {
            "name":     "userId",
            "baseName": "userId",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return PatientAccountPatientRegistrationIPatientRegistrationData.attributeTypeMap;
    }
}
